import { ApiUrl } from 'src/constants';
import { httpService } from 'src/services';

export function getInfrastructureData(lang: string) {
  return httpService.get(`${ApiUrl.getApiUrl().getInfrastructureFilter}`);
}
